import TitleSection from "../../text/TitleSection/TitleSection";
import Section from "../Section";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";

const customerExamples = [
  {
    id: 1,
    title: "Tripadvisor",
    description:
      "Tripadvisor accelerates global campaigns and closes deals faster with Shorthand—cutting build time, empowering designers, and delivering immersive, multilingual stories that wow clients and win pitches.",
    image: (
      <StaticImage
        src="../../../../../static/media/case-studies/Tripadvisor_CaseStudy_Card-IMG.png"
        alt="Tripadvisor case study image"
      />
    ),
    url: "/case-studies/tripadvisor",
  },
  {
    id: 2,
    title: "Honda",
    description:
      "Honda turbocharged its content hub, Engine Room, with Shorthand, boosting dwell time 85% and subscriptions 600% while cutting build time to minutes—fuelling global reach and a 32% ROI jump.",
    image: <StaticImage src="../../../../../static/media/case-studies/case-studies-honda-index.jpg" alt="Honda case study image" />,
    url: "/case-studies/honda",
  },
  {
    id: 3,
    title: "RELX",
    description:
      "RELX transformed internal comms with Shorthand, driving a tenfold surge in reads and a 20-point NPS lift, while slashing cost-per-read and energising 33,000 employees worldwide.",
    image: <StaticImage src="../../../../../static/media/case-studies/case-studies-relx-index.jpg" alt="RELX case study image" />,
    url: "/case-studies/relx",
  },
  {
    id: 4,
    title: "Imperial College London",
    description:
      "Imperial College London doubled engagement with Shorthand, achieving 142% more unique views and 50% longer read times, turning alumni magazines and research features into immersive digital showcases.",
    image: (
      <StaticImage
        src="../../../../../static/media/case-studies/case-studies-imperial-index.jpg"
        alt="Imperial College London case study image"
      />
    ),
    url: "/case-studies/imperial-college-london",
  },
  {
    id: 5,
    title: "Bonhams",
    description:
      "Bonhams supercharged organic traffic and smashed KPIs using Shorthand, publishing 490+ rich stories that spotlight world-class auctions and keep audiences exploring long after the hammer falls.",
    image: (
      <StaticImage src="../../../../../static/media/case-studies/case-studies-bonhams-index.jpg" alt="Bonhams case study image" />
    ),
    url: "/case-studies/bonhams",
  },
  {
    id: 6,
    title: "Seven West Media",
    description:
      "Seven West Media’s MINT studio wows advertisers with Shorthand, delivering a guaranteed 20k+ views on immersive sponsored stories and driving repeat business through fast, flawless, scroll-stopping design.",
    image: (
      <StaticImage
        src="../../../../../static/media/case-studies/SevenWestMedia_CaseStudy_Card-IMG.png"
        alt="Seven West Media case study image"
      />
    ),
    url: "/case-studies/seven-west-media",
  },
];

export default function CaseStudyGrid() {
  return (
    <Section>
      <TitleSection
        title="You’re in good company"
        description="Straight from the source: discover what our customers say about partnering with Shorthand."
      />
      <ul
        role="list"
        className="tw-mx-auto tw-mt-20 tw-grid tw-max-w-2xl tw-grid-cols-1 tw-gap-x-8 tw-gap-y-8 sm:tw-grid-cols-2 lg:tw-mx-0 lg:tw-max-w-none lg:tw-grid-cols-3 lg:tw-gap-x-8 lg:tw-gap-y-16"
      >
        {customerExamples.map(customer => (
          <li
            key={customer.id}
            className="tw-group tw-overflow-hidden tw-rounded-2xl tw-bg-grey_scale-800/50 hover:tw-ring-1 hover:tw-ring-white/20"
          >
            <Link to={customer.url} className="tw-block tw-no-underline hover:tw-no-underline">
              <div className="tw-aspect-[16/9] tw-w-full tw-object-cover tw-outline tw-outline-1 tw--outline-offset-1 tw-outline-black/5">
                {customer.image}
              </div>
              <div className="tw-rounded-t-2xl tw-p-6">
                <h3 className="tw-mt-6 !tw-text-lg/8 tw-font-semibold tw-tracking-tight tw-text-[var(--foreground-color)] group-hover:tw-underline">
                  {customer.title}
                </h3>
                <p className="!tw-text-base tw-text-[var(--foreground-color-muted)] tw-no-underline">{customer.description}</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </Section>
  );
}
